import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'react-qr-code';

/**
 * Generate a QR code as an SVG string using react-qr-code.
 * Uses ReactDOMServer.renderToStaticMarkup so no DOM is needed.
 */
export const generateQrSvgString = (value: string, size = 128): string => {
    const element = createElement(QRCode, { value: value || ' ', size });
    const svgMarkup = renderToStaticMarkup(element);
    // Ensure xmlns is present for standalone SVG usage
    if (!svgMarkup.includes('xmlns=')) {
        return svgMarkup.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
    }
    return svgMarkup;
};
